export default function createUserName(name) {
    let semEspacos = name.replace(/\s/g, '');
    let semAcentos = semEspacos.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    let emMinusculas = semAcentos.toLowerCase();
    return emMinusculas;
}